"use client";

import { createContext, useContext } from "react";
import type { DepositPreset } from "@/lib/wallet/deep-link";

type Shell = {
  chatVisible: boolean;
  /* `preset` picks the deposit rail, currency and network (a deep link). */
  openWallet: (tab?: "Deposit" | "Withdraw" | "Tip", preset?: DepositPreset) => void;
  /* For a flow that leaves the wallet for somewhere else — the email
     verification a withdrawal needs first. */
  closeWallet: () => void;
  openChat: () => void;
  /* An address typed elsewhere — the hero's sign-up panel — arrives filled in. */
  openSignIn: (email?: string) => void;
  /* The identity verification prompt, for a withdrawal refused with
     KYC_REQUIRED (lib/kyc/hooks.ts useHandleKycRequired). */
  openKyc: () => void;
};

export const ShellContext = createContext<Shell>({
  chatVisible: false,
  openWallet: () => {},
  closeWallet: () => {},
  openChat: () => {},
  openSignIn: () => {},
  openKyc: () => {},
});

/* Any button anywhere can open the wallet without prop-drilling through
   half the tree — the shell owns the modal, the tree just asks for it. */
export const useShell = () => useContext(ShellContext);
